import { render, staticRenderFns } from "./ReportSafetyList.vue?vue&type=template&id=6b85e6e8&scoped=true"
import script from "./ReportSafetyList.vue?vue&type=script&lang=js"
export * from "./ReportSafetyList.vue?vue&type=script&lang=js"
import style0 from "./ReportSafetyList.vue?vue&type=style&index=0&id=6b85e6e8&prod&lang=scss&scoped=true"
import style1 from "./ReportSafetyList.vue?vue&type=style&index=1&id=6b85e6e8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b85e6e8",
  null
  
)

export default component.exports